import { PARTNER_ID_KEY } from 'screens/VideoCalls/utils/constants'
import { safeGetLocalStorageItem } from 'utils/localStorage'
import { getObject, LocalStorageKeys } from 'utils/storage'
import type { Options } from '@segment/analytics-next'

type UtmParams = {
  utm_campaign?: string
  utm_source?: string
  utm_medium?: string
  utm_term?: string
  utm_content?: string
  [key: string]: string | undefined
}

export const getStoredUtmParams = () => getObject<UtmParams>(LocalStorageKeys.UtmParams)

export const getStoredAttributionProperties = () => {
  const utmParams = getStoredUtmParams()
  const entryPartner = safeGetLocalStorageItem(PARTNER_ID_KEY)

  return {
    ...utmParams,
    ...(entryPartner ? { entry_partner: entryPartner } : {})
  }
}

export const getStoredUtmCampaignOptions = (): Options | undefined => {
  const utmParams = getStoredUtmParams()

  if (!utmParams) {
    return undefined
  }

  const campaign = Object.fromEntries(
    Object.entries({
      name: utmParams.utm_campaign,
      source: utmParams.utm_source,
      medium: utmParams.utm_medium,
      term: utmParams.utm_term,
      content: utmParams.utm_content
    }).filter((entry): entry is [string, string] => Boolean(entry[1]))
  )
  const hasCampaignContext = Object.keys(campaign).length > 0

  if (!hasCampaignContext) {
    return undefined
  }

  return { context: { campaign } } as Options
}
